import * as Types from '../../types/gql';

export type BalancesVariables = Types.Exact<{ [key: string]: never }>;

export type Balances = {
  currentUser?: Types.Maybe<{
    id: string;
    balances?: Types.Maybe<
      Array<{ amount?: Types.Maybe<{ value: string; currency: { code: string } }> }>
    >;
  }>;
};
